import { IOption } from 'shared-components';

import { ActionSelection } from '../../../types';
import { hasPerm, P } from '@/utilities/roles/permissions';
import { UserRole } from '@/store/auth/types';
import { IUser } from 'types';

export const getResetMfaOptions = (userRole: UserRole, studentUserRecord: IUser | null): Array<IOption> => {
  if (!hasPerm(userRole, P.RESET_MFA) || !studentUserRecord) return [];
  if (studentUserRecord && !studentUserRecord.mfaEnabled) return [];

  return [
    {
      label: 'Reset MFA',
      value: ActionSelection.RESET_MFA,
    },
  ];
};
